import {Container, VStack} from "@chakra-ui/react";
import Headline from "../components/Headline";
import Advantage from "../components/Advantage";
import React from "react";

function Home(props) {
    return (
        <Container maxW={"7xl"} paddingX={8}>
            <VStack
                overflow={'hidden'}
            >
                <Headline/>
                <Advantage/>
                <Advantage/>
                <Advantage/>
            </VStack>
        </Container>
    );
}

export default Home;
